import React from 'react';
import styles from './AddressSummary.module.scss';
import { mapCountry } from '../../utils';

const AddressSummary = ({
  email = '',
  phone = '',
  firstName,
  lastName,
  streetAddress,
  postalCode,
  city,
  country,
  state,
  showContactInfo = false,
  additionalStreetInfo = '',
}: {
  email?: string;
  phone?: string;
  firstName: string;
  lastName: string;
  streetAddress: string;
  postalCode: string;
  city: string;
  country: string;
  state: string;
  showContactInfo?: boolean;
  additionalStreetInfo?: string;
}) => (
  <div className={styles['address-summary-container']} data-private>
    <div>
      <div className={styles['address-summary-body']}>
        <div>{`${firstName.toLowerCase()} ${lastName.toLowerCase()}`}</div>
        <div>{streetAddress.toLowerCase()}</div>
        <div>{additionalStreetInfo.toLowerCase()}</div>
        <div>
          {`${city.toLowerCase()},
              ${state.toUpperCase()} ${postalCode}
              ${mapCountry(country.toUpperCase())}`}
        </div>
      </div>
    </div>
    {showContactInfo && (
      <div className={styles['contact-info-container']}>
        <div>
          <div className={styles['summary-body']}>{phone}</div>
          <div className={styles['summary-body']}>{email}</div>
        </div>
      </div>
    )}
  </div>
);

export default AddressSummary;
